module.exports = __webpack_public_path__ + "img/media_20120218.4bc3b955.jpg";